import React from 'react';

interface Transaction {
    from: string;
    to: string;
    amount: number;
}

interface ShareResultPreviewProps {
    meetingName: string;
    totalAmount: number;
    perPerson: number;
    transactions: Transaction[];
}

export const ShareResultPreview: React.FC<ShareResultPreviewProps> = ({
    meetingName,
    totalAmount,
    perPerson,
    transactions
}) => {
    return (
        <div className="result-preview">
            <div className="preview-header">
                <div className="preview-title">{meetingName}</div>
                <div className="preview-badge">정산 완료</div>
            </div>

            <div className="preview-summary">
                <div className="summary-item">
                    <div className="summary-label">총 지출</div>
                    <div className="summary-value">{totalAmount.toLocaleString('ko-KR')}원</div>
                </div>
                <div className="summary-divider"></div>
                <div className="summary-item">
                    <div className="summary-label">1인당</div>
                    <div className="summary-value">{perPerson.toLocaleString('ko-KR')}원</div>
                </div>
            </div>

            <div className="preview-transactions">
                <div className="transactions-title">💸 정산 내역</div>
                {transactions.map((transaction, index) => (
                    <div key={index} className="transaction-row">
                        <span className="transaction-from">{transaction.from}</span>
                        <span className="transaction-arrow">→</span>
                        <span className="transaction-to">{transaction.to}</span>
                        <span className="transaction-amount">{transaction.amount.toLocaleString('ko-KR')}원</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
